import { connect } from 'react-redux';
import { IAuthSettingsState } from '@piwikpro/auth-crate/reducers/auth';
import TwoFactorConfigureOverlay from './TwoFactorConfigureOverlay';

const mapStateToProps = (state: { authSettings: IAuthSettingsState }) => ({
  setupCompleted: state.authSettings.user.setup.completed,
  twoFactorAuthEnforced: state.authSettings.user.twoFactorAuth.enforced,
});

export default connect(mapStateToProps, null)(TwoFactorConfigureOverlay);
